<template>
  <div class="jobs">
    <div class="banner">心系工程 追求更好</div>

    <!-- 搜索 -->
    <div ref="searchBar" :class="{ fixedTop: searchBarFixedTop }" class="search-wrapper">
      <input-search :size="searchBarFixedTop ? 'small' : 'medium'" placeholder="请输入职位搜索" v-model="keyword"></input-search>
    </div>

    <div class="main clearfix">
      <!-- 侧边栏过滤选择 -->
      <div class="clearfix aside-filter">
        <div class="header">
          <span>选择</span>
          <span :class="{ clearable }" class="clear" @click="clearFilter">清空</span>
        </div>

        <div class="job-category job-filter-block">
          <checkbox-transfer title="请选择" ref="checkboxList" v-model="checkboxParam" :props="{ key: 'id', label: 'name' }" :data="checkboxList"></checkbox-transfer>
        </div>
      </div>

      <!-- 主体内容 -->
      <div class="content">

        <h2 class="content-title">拟招聘的职位 ({{ total }})</h2>

        <ul class="content-list" v-if="postList.length > 0">
          <template v-for="post in postList">
            <li class="content-item" :key="post.id" v-if="post.orgnList.length > 0">
              <campus-post-card :post="post" :on-success="clickEvent"></campus-post-card>
            </li>
          </template>
        </ul>
        <ghidri-empty v-else>本次招聘暂未开始，敬请期待</ghidri-empty>

        <!-- 分页器 -->
        <div v-show="!loading" class="pagination-wrapper">
          <pagination :current-page.sync="currentPage" :total="total"></pagination>
        </div>

      </div>

    </div>

    <el-backtop :bottom="100"></el-backtop>

  </div>
</template>

<script>
  import campusMajorCategoryApi from "@/api/campus/majorCategory.js";
  import campusPostApi from "@/api/campus/campusPost.js";

  import { getOffsetTop } from "@/util/utilities";

  import CampusPostCard from "./post/card.vue"

  let positionY = 0;
  let searchBarClientHeight = 0;

  export default {
    name: "Campus",
    components: {
      CampusPostCard,
    },
    data() {
      return {
        keyword: "",

        postList: [],//职位列表

        checkboxList: [], //checkbox查询列表
        checkboxParam: [],//查询参数

        searchBarFixedTop: false,
        loading: false,

        currentPage: 1,
        total: 0
      };
    },
    created() {
      const _this = this;
      _this.loadingIns = _this.$loading();

      const categoryRequest = _this.initCategory();
      const dataRequest = _this.fetchList();

      Promise.all([categoryRequest, dataRequest]).then(() => {
        _this.loadingIns.close();
      }).catch((err) => {
        _this.loadingIns.close();
      });
    },
    mounted() {
      this.$nextTick(() => {
        positionY = getOffsetTop(document.body, this.$refs.searchBar);
        searchBarClientHeight = this.$refs.searchBar.clientHeight;
      });

      const onPageScroll = () => {
        const top = this.$refs.searchBar.getBoundingClientRect().top;
        this.searchBarFixedTop = window.scrollY > positionY - searchBarClientHeight / 2;
      };
      window.addEventListener("scroll", onPageScroll);

      this.$on("hook:destroyed", () => {
        window.removeEventListener("scroll", onPageScroll);
      });
    },
    computed: {
      queryFilter() {
        return {
          checkboxParam: this.checkboxParam.length > 0 ? this.checkboxParam.join("-") : "",
          keyword: this.keyword,
          offset: Math.max(0, this.currentPage - 1) * 10
        };
      },
      clearable() {
        return (
          this.checkboxParam.length !== 0 || this.checkboxParam.length !== 0
        );
      }
    },
    watch: {
      queryFilter: function(newVal, oldVal) {
        this.searchBarFixedTop && window.scrollTo(0, positionY);
        this.fetchList();
      }
    },
    methods: {
      initCategory() {
        const _this = this;
        campusMajorCategoryApi.getEnable().then(res => {
          if (res.success) {
            _this.checkboxList = res.data;
          }
        }).catch();
      },
      fetchList() {
        let _this = this;
        _this.loading = true;
        campusPostApi.search(_this.queryFilter).then(res => {
          const result = res.data;
          const data = result.records;
          if (_this.total !== result.total) {
            _this.currentPage = 1;
          }
          _this.total = result.total;
          _this.postList = data;
          _this.loading = false;
        }).catch((err) => {
          console.log("err", err);
          _this.loading = false;
          _this.$message.error(err || "网络出错，请稍后再试");
        });
      },
      clearFilter() {
        if (this.checkboxParam.length) {
          this.checkboxParam = [];
        }
      },
      clickEvent(item) {
        this.$router.push({ path: "/campus/post/" + item.id });
      }
    }
  };
</script>

<style lang="less" scoped>
  .banner {
    height: 400px;
    line-height: 400px;
    color: #fff;
    width: 100%;
    min-width: @main-width;
    background-image: url("/img/buss/wind.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    text-align: center;
    font-size: @font-size-larger;
  }

  .main {
    width: @main-width;
    margin: 0 auto;
    margin-top: 100px;
    padding: 0 100px;

    .aside-filter {
      float: left;
      width: 300px;
      padding-right: 20px;

      .header {
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        border-bottom: 1px solid @border-lighter-color;
        padding-bottom: 10px;
        width: 100%;

        .clear {
          &.clearable {
            color: @main-color;
            cursor: pointer;
          }
        }
      }

      .job-filter-block {
        margin-bottom: 40px;
      }
    }

    .content {
      min-height: 500px;
      padding-left: 20px;
      border-left: 1px solid @border-lighter-color;
      margin-left: 300px;

      &-title {
        margin-bottom: 30px;
      }

      .pagination-wrapper {
        margin-top: 10px;
        text-align: right;
      }
    }
  }
</style>
